import React, { useEffect, useState } from "react"
import { MaterialReactTable } from "material-react-table"
import { CheckCircle, Cancel, Refresh } from "@mui/icons-material"
import { IconButton, Tooltip } from "@mui/material"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"

const CustomReadableTable = ({ endpoint, columnsTable }) => {
  const [data, setData] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(false)

  const fetchData = async () => {
    try {
      setIsLoadingData(true)
      let response = await fetchwrapper(endpoint)
      response = await response.json()
      setData(response.data)
    } catch (error) {
      console.error("Error fetching data:", error)
    } finally {
      setIsLoadingData(false)
    }
  }

  useEffect(() => {
    // Cargar los datos desde el endpoint
    fetchData()
  }, [endpoint])

  // Definir las columnas con la columna adicional para los íconos
  const columnsWithIcon = [
    {
      header: "Estado", // Título de la columna
      accessorKey: "msgtipo", // Aquí asumirás que msgtipo está en los datos
      Cell: ({ cell }) => {
        // Mostrar el ícono según el valor de msgtipo
        const msgtipo = cell.getValue()
        if (msgtipo === "S") {
          return <CheckCircle color="success" /> // Ícono de check (verde)
        } else if (msgtipo === "E") {
          return <Cancel color="error" /> // Ícono de X (rojo)
        }
        return null // Si no es 'S' ni 'E', no mostrar nada
      },
    },
    ...columnsTable, // Las demás columnas que vienen como prop
  ]

  return (
    <>
      <CustomBackdrop isLoading={isLoadingData} />
      <MaterialReactTable
        columns={columnsWithIcon} // Usamos las columnas modificadas con íconos
        data={data} // Usamos los datos obtenidos del endpoint
        initialState={{ showColumnFilters: true }} // Mostrar los filtros por defecto
        renderTopToolbarCustomActions={() => (
          <Tooltip title="Recargar datos">
            <IconButton onClick={fetchData}>
              <Refresh />
            </IconButton>
          </Tooltip>
        )}
      />
    </>
  )
}

export default CustomReadableTable
